import { createAction } from '@reduxjs/toolkit';

const updateAllPacket = createAction('updateAllPacket');
const removePacket = createAction('removePacket');

export { updateAllPacket, removePacket };

export default {};
